<template>
  <footer class="footer-area footer-style-01 pt--80">
    <div id="newsletter" class="im-call-to-action-area pb--70" v-if="showNewsletter">
      <Contact />
    </div>
    <div class="footer-wrapper pb--70">
      <v-container class="container">
        <v-row class="pb--20">
          <v-col lg="3" md="6" sm="12" cols="12">
            <div class="footer-logo">
              <a href="/"><img :src="brandLogo" :alt="brandLogoAlt"/></a>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="hasContactColumn" lg="4" md="6" sm="12" cols="12">
            <div class="footer-link" v-if="hasAddress">
              <h4>{{ $t('footer.address.header') }}</h4>
              <div v-html="$t('footer.address.content')" class="white--text"></div>
            </div>
            <div class="footer-link" :class="{'mt--40': hasAddress}" v-if="hasContact">
              <h4>{{ $t('footer.contact.header') }}</h4>
              <div v-html="$t('footer.contact.contentParagraph1')" class="white--text"></div>
            </div>
            <!--Right Side Buttons-->
            <SocialIconsBar />
          </v-col>
          <v-col v-if="hasMenuColumn" lg="4" md="6" sm="12" cols="12" class="mt_mobile--40">
            <div class="footer-link" v-if="hasMenu">
              <h4>{{ $t('footer.menu.header') }}</h4>
              <div v-html="$t('footer.menu.content')" class="white--text"></div>
            </div>
            <!-- Dokumenty: linki budowane z docLinks (sekcja „Dokumenty” w panelu); puste wpisy pomijane -->
            <div class="footer-link footer-documents" :class="{'mt--40': hasMenu}" v-if="hasDocuments">
              <h4>{{ documentsHeader }}</h4>
              <nav class="footer-document-links white--text" :aria-label="documentsHeader">
                <a v-for="doc in documentLinks" :key="doc.key" :href="doc.href" target="_blank" rel="noopener">{{ doc.label }}</a>
              </nav>
            </div>
            <div class="footer-link mt--40" v-if="hasGardensBlock">
              <h4>{{ $t('footer.gardens.header') }}</h4>
              <div v-html="$t('footer.gardens.content')" class="white--text"></div>
            </div>
          </v-col>
          <v-col :lg="hoursColSpan" md="6" sm="12" cols="12" class="mt_md--40 mt_sm--40 pl--0 pr--0">
            <div class="footer-link">
              <h4>{{ $t('footer.openingHours.header') }}</h4>
              <div v-html="$t('footer.openingHours.content')" class="white--text oppening-hours"></div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mt--20">
            <div class="white--text col-sm-12">
              Copyright © {{ new Date().getFullYear() }} {{ $t('footer.copyrightText') }}
            </div>
        </v-row>
      </v-container>
    </div>
  </footer>
</template>

<script>
  import Contact from "@/components/garden-of-lights/Contact.vue";
  import {getLandingPageSettings} from "@/scripts/settings";
  import SocialIconsBar from "@/components/garden-of-lights/SocialIconsBar.vue";

  export default {
    components: {SocialIconsBar, Contact},
    data() {
      return {
        // domyślnie widoczny — ukrywamy tylko tam, gdzie ustawienia mówią to wprost
        showNewsletter: true,
        socialCount: 0,
      };
    },
    computed: {
      // logo marki bierzemy z konfiguracji landingu; fallback = dotychczasowy plik,
      // dzięki czemu istniejące landingi renderują się bez zmian
      brandLogo() {
        return this.i18nValue('logo.logoGOL') || '/images/logo-gol-1line.svg';
      },
      brandLogoAlt() {
        return this.i18nValue('logo.alt') || 'Garden of Lights logo';
      },
      // pierwsza kolumna stopki: adres, kontakt i ikony social — pusta znika,
      // a godziny otwarcia rozciągają się na zwolnione miejsce
      hasContactColumn() {
        return this.hasAddress || this.hasContact || this.socialCount > 0;
      },
      hoursColSpan() {
        return 12 - (this.hasContactColumn ? 4 : 0) - (this.hasMenuColumn ? 4 : 0);
      },
      // nagłówek bez treści to pusta sekcja — chowamy cały blok
      hasAddress() {
        return !!this.i18nValue('footer.address.content');
      },
      hasContact() {
        return !!this.i18nValue('footer.contact.contentParagraph1');
      },
      hasMenu() {
        return !!this.i18nValue('footer.menu.header');
      },
      hasGardensBlock() {
        return !!this.i18nValue('footer.gardens.header');
      },
      // Linki do dokumentów: ścieżki z docLinks, etykiety z footer.documents.<klucz>.
      // Wpis bez ścieżki nie jest renderowany, więc nie powstają martwe odnośniki.
      documentLinks() {
        const keys = ['exhibitionTerms', 'onlineTicketsTerms', 'privacyPolicy', 'newsletterTerms', 'serviceTerms'];
        return keys
            .map((key) => ({key, href: this.i18nValue('docLinks.' + key),
                            label: this.i18nValue('footer.documents.' + key) || key}))
            .filter((doc) => doc.href);
      },
      hasDocuments() {
        return this.documentLinks.length > 0;
      },
      documentsHeader() {
        return this.i18nValue('footer.documents.header') || 'Dokumenty';
      },
      hasMenuColumn() {
        // Warunek jak w oryginale (na nagłówkach) — plus blok dokumentów, gdy ma co pokazać.
        return this.hasMenu || this.hasGardensBlock || this.hasDocuments;
      },
    },
    created() {
      this.fetchGardenSettings();
    },
    methods: {
      // $t zwraca ścieżkę klucza, gdy klucza nie ma — traktujemy to jako brak wartości
      i18nValue(key){
        const translated = this.$t(key);
        return typeof translated === 'string' && translated !== key ? translated.trim() : '';
      },
      fetchGardenSettings(){
        // ustawienia bieżącego ogrodu: flaga newslettera i lista profili social
        const garden = this.$route.params.garden;
        if(!garden){
          return;
        }
        getLandingPageSettings(garden).then((settings) => {
          this.showNewsletter = settings.activateNewsletterSection !== false;
          this.socialCount = (settings.socialList || []).filter((item) => item && item.url).length;
        });
      },
    },
  };
</script>

<style scoped>
.footer-link.footer-documents h4 {
  margin-bottom: 14px;
}
.footer-document-links {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  line-height: 1.5;
}
</style>
